import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import DialogTitle from '@mui/material/DialogTitle';

function ObiActionTitleForDialog(props) {
  return (
    <DialogTitle id="form-dialog-title">
      <Grid container spacing={2} alignItems={(props.alignItems)? props.alignItems : 'flex-start'}>
        <Grid item xs={(!props.children)? 12 : 9}>
          <Typography variant={(props.variant)? props.variant : 'h6'} style={{color: (props.color)? props.color: ''}}>
            {props.title}{(props.subtype === 'span')? ' ': ''}
            {(props.subtype === 'span')? 
              <Typography variant={(props.subvariant)? props.subvariant :'body1'}  component='span' style={{color: props.subcolor}}>
                {props.subtitle}
              </Typography>: ''}
          </Typography>
          {(props.subtitle && (!props.subtype || props.subtype !== 'span'))?
          <Typography variant={(props.subvariant)? props.subvariant :'body1'} component={(props.subtype)? props.subtype : ''} style={{color: props.subcolor}}>
            {props.subtitle}
          </Typography>: ''}
        </Grid>
        {(!props.children)? '' :
          <Grid item xs={3} sm>
            <Grid container justifyContent={'flex-end'}>
              {props.children}
            </Grid>
          </Grid> }
      </Grid>
    </DialogTitle>
  );
  
}
function ObiActionTitleForCard(props) {
  return (
    <Grid container spacing={2} alignItems={(props.alignItems)? props.alignItems : 'center'} >
      <Grid item xs={(!props.children)? 12 : 9}>
        <Typography variant={(props.variant)? props.variant : 'h5'} component={(props.subtype)? props.subtype : ''} style={{color: props.color}}>
          {props.title}
        </Typography>
        {(props.subtitle)?
        <Typography variant={(props.subvariant)? props.subvariant : 'subtitle2'} component={(props.subtype)? props.subtype : ''} style={{color: props.subcolor}}>
          {props.subtitle}
        </Typography>: ''}
      </Grid>
      {(!props.children)? '' :
          <Grid item xs={3} sm>
            <Grid container justifyContent={'flex-end'}>
              {props.children}
            </Grid>
          </Grid> }
    </Grid>
  );
  
}

export default function ObiActionTitle(props) {
  if(!props.type){
    return ObiActionTitleForCard(props);
  }
  switch(props.type){
    case 'dialog':
      return ObiActionTitleForDialog(props);
    default:
      return ObiActionTitleForCard(props);
  }
}